import React, { useState, useEffect } from "react";
import {
    Form,
    Button,
    Typography,
    message,
    Spin
} from "antd";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../../pageHeader/LeftLayout";
import { routes } from "../../../routes/Routes";
import { COMMON_ERROR_MSG, SESSION_TOKEN } from "../../../constants/constants";
import IntegerInput from "../../../components/IntergerInput";
import _AdministratorService from "../../../modules/AdministratorService";

import HeaderComponentWithTitleAndLogo from "../../../components/HeaderComponentWithTitleAndLogo/HeaderComponentWithTitleAndLogo";
import MainLayout from "../../../components/MainLayout/MainLayout";
import VerifyOtp from "../../../components/VerifyOtp/VerifyOtp";

const { Title, Text } = Typography;

const AdministratorVerifyOTP = () => {
    const history = useHistory();
    const [timer, setTimer] = useState(120);
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    let data = location.state;
    let emailId = "";
    if (data && data.email) {
        emailId = data.email;
    }

    const [email] = useState(emailId);

    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => setTimer((t) => t - 1), 1000);
            return () => clearInterval(interval);
        }
    }, [timer]);


    const onBack = () => {
        history.push(routes.createAdministratorAccount.path);
    };

    const onFinish = async (values) => {
        const reqObj = {
            Email: email,
            EmailOTP: values.otp,
        }
        setLoading(true);
        try {
            const res = await _AdministratorService.confirmEmailOTP(reqObj);
            if (res?.data?.IsSuccess) {
                message.success(res.data.Message);
                localStorage.setItem("adminiStratorLoginEmail", res?.data?.Obj?.Email);
                localStorage.setItem("administratorUserId", res?.data?.Obj?.Id);
                localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
                localStorage.setItem("userRole", res?.data?.Obj?.Role);
                localStorage.setItem("IsConsumerFlag", JSON.stringify(false));
                localStorage.setItem("IsAdministratorFlag", JSON.stringify(true));
                history.push({
                    pathname: routes.createAdministratorLoginPassword.path,
                    state: { email }
                }
                );
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG)
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.log(err)
        }
    };

    const handleResendOtp = async () => {
        const reqObj = {
            Email: email
        }
        setLoading(true);
        try {
            const res = await _AdministratorService.sendVerifyEmailOTP(reqObj);
            if (res?.data.IsSuccess) {
                message.success(res.data.Message);
                setTimer(120); // Reset timer to 30 seconds
                setLoading(false);
            } else {
                setLoading(false);
                message.error(res.data.Message);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    }
    return (
        <Spin spinning={loading}>

      <MainLayout>
        <HeaderComponentWithTitleAndLogo
          logoSrc="/websiteLogo.png"
          logoAlt="Leveridge Logo"
          title="Verify Your Email"
        />
        <VerifyOtp
          email={email}
          timer={timer}
          onFinish={onFinish}
          onBack={onBack}
          handleResendOtp={handleResendOtp}
        />
      </MainLayout>
            {/* <LeftLayout>
                <div className="w450">
                    <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3", marginBottom: 60 }}>
                        Administrator Portal
                    </Title>

                    <Title level={4} style={{ marginBottom: 12 }}>
                        Verify Your Email
                    </Title>

                    <Text type="secondary" style={{ display: "block", marginBottom: 24 }}>
                        A six digit OTP was sent to <Text strong>{email}</Text>
                    </Text>

                    <Form layout="vertical" onFinish={onFinish} requiredMark={true}>
                        <Form.Item
                            label="Enter OTP"
                            name="otp"
                            rules={[{ required: true, message: "OTP is required" },
                            {
                                pattern: /^\d{6}$/,
                                message: "OTP must be a 6-digit number",
                            },
                            ]}
                        >
                            <IntegerInput
                                maxLength={6}
                                placeholder="Enter 6-digit OTP"
                                autoComplete="one-time-code"
                            />
                        </Form.Item>

                        <Form.Item>
                            <div style={{ display: "flex", gap: 16, marginTop: 20 }}>
                                <Button
                                    onClick={onBack}
                                    icon={<LeftOutlined />}
                                >
                                    Go Back
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                >
                                    Confirm OTP <RightOutlined />
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>

                    <Text type="secondary" style={{ display: "block", marginTop: 40 }} className="mb-10">
                        Please wait 120 seconds before resending a new OTP:{" "}
                        <span style={{ fontWeight: "bold" }}>
                            00:{timer.toString().padStart(2, "0")}
                        </span>
                    </Text>
                    <Button shape="round" disabled={timer > 0} onClick={handleResendOtp}>Resend</Button>
                </div>
            </LeftLayout> */}
        </Spin>
    );
};

export default AdministratorVerifyOTP;